// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.46.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#main-content-card.main-content.v-card.v-sheet.theme--light[data-v-75f2361b]{padding:0}#account-layout[data-v-75f2361b]{background-color:#eee;height:100vh}hr.v-divider[data-v-75f2361b]{margin:0}", ""]);
// Exports
module.exports = exports;
